import i18n from "@/i18n";
import React from "react";
import { AlertTriangle } from "lucide-react";

// STANDARD shared counter — whether the payroll quantities stored in this
// Close are final. Read-only; never changes the Close.
const STATUS_TEXT = {
    get PENDING() { return i18n.t("wf.StandardCloseValidity.STATUS_TEXT.PENDING", "Payroll hours pending — reviewed hours from another restaurant or earlier days are still missing"); },
    get UNRESOLVED() { return i18n.t("wf.StandardCloseValidity.STATUS_TEXT.UNRESOLVED", "Payroll hours not calculated — this case is not supported yet"); },
    get NOT_CURRENT() { return i18n.t("wf.StandardCloseValidity.STATUS_TEXT.NOT_CURRENT", "Payroll hours no longer current — reviewed hours changed after this Close"); },
};
const ACTION_TEXT = {
    get WAIT_FOR_SOURCE_REVIEW() { return i18n.t("wf.StandardCloseValidity.ACTION_TEXT.WAIT_FOR_SOURCE_REVIEW", "When the listed days are reviewed, Reopen and Close again. No other restaurant needs to close its period."); },
    get REOPEN_AND_RECLOSE() { return i18n.t("wf.StandardCloseValidity.ACTION_TEXT.REOPEN_AND_RECLOSE", "Reopen the period and Close it again before creating new payroll files."); },
    get RESOLVE_THEN_REOPEN_AND_RECLOSE() { return i18n.t("wf.StandardCloseValidity.ACTION_TEXT.RESOLVE_THEN_REOPEN_AND_RECLOSE", "Resolve the listed case, then Reopen and Close again."); },
};
const PENDING_REASON = {
    get ACTUAL_NOT_REVIEWED() { return i18n.t("wf.StandardCloseValidity.PENDING_REASON.ACTUAL_NOT_REVIEWED", "hours not reviewed"); },
    get PUBLISHED_SHIFT_NOT_REVIEWED() { return i18n.t("wf.StandardCloseValidity.PENDING_REASON.PUBLISHED_SHIFT_NOT_REVIEWED", "published shift not reviewed"); },
    get CLOCK_EVENT_NOT_REVIEWED() { return i18n.t("wf.StandardCloseValidity.PENDING_REASON.CLOCK_EVENT_NOT_REVIEWED", "clock event not reviewed"); },
};

const pendingLabel = (p) =>
    `${p.date} · ${p.other_restaurant ? (p.restaurant_name || i18n.t("wf.scv.anotherRestaurant", "another restaurant")) : i18n.t("wf.scv.thisRestaurant", "this restaurant")} · `
    + `${PENDING_REASON[p.reason] || i18n.t("wf.scv.notReviewed", "not reviewed")}`;

export const StandardCloseValidity = ({ closeState }) => {
    const data = closeState && closeState.standard_validity;
    if (!data || data.payroll_quantities === "VALID") return null;
    const rows = (data.employees || []).filter((e) => e.current_status !== "VALID");
    return (
        <div data-testid="standard-close-validity"
            className="rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900 space-y-2">
            {rows.map((e) => (
                <div key={e.employee_id} data-testid={`standard-validity-${e.employee_id}`}>
                    <div className="flex items-start gap-2 font-medium">
                        <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0" />
                        <span data-testid={`standard-validity-status-${e.employee_id}`}>
                            {e.employee_name ? `${e.employee_name}: ` : ""}{STATUS_TEXT[e.current_status]}
                        </span>
                    </div>
                    {(e.pending || []).map((p, i) => (
                        <div key={i} className="ml-6" data-testid={`standard-validity-pending-${e.employee_id}-${i}`}>
                            {pendingLabel(p)}
                        </div>
                    ))}
                </div>
            ))}
            <div data-testid="standard-validity-action" className="text-amber-800">
                {ACTION_TEXT[data.recommended_action]}
            </div>
        </div>
    );
};

export default StandardCloseValidity;
